import React, { useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Collapse, Tooltip } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { userSignOut } from 'actions/Auth';
import AvatarIcon from 'components/organisms/Headers/ProfileHeader/AvatarIcon';
import IntlMessages from 'util/IntlMessages';

const ICON_SIZE = 45;

function UserInfo() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.authUser);
  const [showMenu, setShowMenu] = useState(false);

  const navigate = (route) => {
    history.push(`/app/${route}`);
    setShowMenu(false);
  };

  const handleLogout = () => {
    setShowMenu(false);
    dispatch(userSignOut());
  };

  const formattedRoles =
    user?.roles?.map((role) => role.charAt(0).toUpperCase() + role.slice(1).replace(/_/g, ' ')).join(', ') || '';

  const associatedMerchantSlug = user?.merchants?.[0];

  return (
    <section className="user-profile">
      <div
        className="d-flex align-items-center justify-content-between pr-2 w-100 pt-1"
        onClick={() => setShowMenu((state) => !state)}
      >
        <AvatarIcon
          type={user?.type === 'merchant' ? 'merchant' : 'default'}
          data={{ slug: associatedMerchantSlug, active: true }}
          size={ICON_SIZE}
        />
        <div className="user-detail">
          <Tooltip title={user?.name}>
            <h4 className="user-name d-flex justify-content-around">
              <span className="text-truncate">{user?.name}</span>
            </h4>
          </Tooltip>
          <Tooltip title={formattedRoles}>
            <h4 className="user-role d-flex text-truncate">
              <span className="text-truncate">{formattedRoles}</span>
            </h4>
          </Tooltip>
          <Tooltip title={user?.email ?? ''}>
            <h4 className="user-email d-flex">
              <span className="text-truncate">{user?.email}</span>
            </h4>
          </Tooltip>
        </div>
        <i
          className={`zmdi zmdi-chevron-down zmdi-hc-lg align-middle transition-all-3 ${showMenu && 'wi-rotate-180'}`}
        />
      </div>

      <Collapse in={showMenu} onClick={(e) => e.stopPropagation()} className="menu-collapse">
        <MenuItem onClick={() => navigate(`profile/${user.id}`)} className="menu-item">
          <i className="zmdi zmdi-account zmdi-hc-lg mr-2" />
          <IntlMessages id="popup.profile" />
        </MenuItem>
        <MenuItem onClick={handleLogout} className="menu-item">
          <i className="zmdi zmdi-sign-in zmdi-hc-lg mr-2" />
          <IntlMessages id="popup.logout" />
        </MenuItem>
      </Collapse>
    </section>
  );
}

export default UserInfo;
